import React, { useEffect, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { FaBars, FaTimes, FaMoon, FaSun, FaWhatsapp } from 'react-icons/fa';
import { whatsappBookCallUrl } from '../constants/whatsapp';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('theme');
    const initialDark = stored ? stored === 'dark' : true;
    setDarkMode(initialDark);
    document.documentElement.classList.toggle('dark', initialDark);
  }, []);

  const toggleTheme = () => {
    const next = !darkMode;
    setDarkMode(next);
    document.documentElement.classList.toggle('dark', next);
    localStorage.setItem('theme', next ? 'dark' : 'light');
  };

  return (
    <div className='fixed top-0 left-0 w-full h-[80px] flex justify-between items-center px-4 bg-white text-gray-900 dark:bg-[#0a192f] dark:text-gray-300 z-50'>
      <div className='flex flex-col'>
        <ScrollLink to='about' smooth={true} duration={500} offset={-80} className='cursor-pointer'>
          <h1 className='font-semibold text-xl dark:text-gray-100'>Johnedel Mapa</h1>
          <p className='text-base font-light text-gray-500 dark:text-gray-300'>
            <span className='text-gray-600 dark:text-gray-300'>Full-Stack Developer</span>
            <span className='text-pink-600 dark:text-pink-400'> · Automation Consultant</span>
          </p>
        </ScrollLink>
      </div>

      {/* menu */}
      <ul className='hidden md:flex items-center gap-4'>
        <li>
          <ScrollLink to='about' smooth={true} duration={500} offset={-80} className='cursor-pointer'>About</ScrollLink>
        </li>
        <li>
          <ScrollLink to='case-studies' smooth={true} duration={500} offset={-80} className='cursor-pointer'>
            Case studies
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to='solutions' smooth={true} duration={500} offset={-80} className='cursor-pointer'>
            Solutions
          </ScrollLink>
        </li>
        <li>
          <ScrollLink to='work-together' smooth={true} duration={500} offset={-80} className='cursor-pointer'>
            Work together
          </ScrollLink>
        </li>
        {whatsappBookCallUrl && (
          <li>
            <a
              href={whatsappBookCallUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='group inline-flex items-center gap-2 rounded-md border-2 border-[#25D366] px-3 py-1.5 text-sm font-medium text-gray-900 bg-[#25D366]/10 hover:bg-[#25D366] hover:text-white transition-colors duration-200 dark:text-[#ccd6f6] dark:bg-[#25D366]/15 dark:hover:text-white'
            >
              <FaWhatsapp className='text-lg text-[#25D366] shrink-0 group-hover:text-white transition-colors' aria-hidden />
              Book a call
            </a>
          </li>
        )}
        <li>
          <button
            onClick={toggleTheme}
            aria-label='Toggle dark mode'
            className='p-2 rounded-md border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800'
          >
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-40'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-white dark:bg-[#0a192f] flex flex-col justify-center items-center z-30'
        }
      >
        <li className='py-6 text-4xl'>
          <ScrollLink to='about' smooth={true} duration={500} offset={-80} onClick={handleClick} className='cursor-pointer'>About</ScrollLink>
        </li>
        <li className='py-6 text-4xl'>
          <ScrollLink to='case-studies' smooth={true} duration={500} offset={-80} onClick={handleClick} className='cursor-pointer'>
            Case studies
          </ScrollLink>
        </li>
        <li className='py-6 text-4xl'>
          <ScrollLink to='solutions' smooth={true} duration={500} offset={-80} onClick={handleClick} className='cursor-pointer'>
            Solutions
          </ScrollLink>
        </li>
        <li className='py-6 text-4xl'>
          <ScrollLink to='work-together' smooth={true} duration={500} offset={-80} onClick={handleClick} className='cursor-pointer'>
            Work together
          </ScrollLink>
        </li>
        {whatsappBookCallUrl && (
          <li className='py-6'>
            <a
              href={whatsappBookCallUrl}
              target='_blank'
              rel='noopener noreferrer'
              onClick={handleClick}
              className='group inline-flex items-center gap-3 border-2 border-[#25D366] px-8 py-4 text-2xl sm:text-3xl font-medium text-gray-900 bg-[#25D366]/10 hover:bg-[#25D366] hover:text-white transition-colors duration-200 dark:text-[#ccd6f6] dark:bg-[#25D366]/15 dark:hover:text-white'
            >
              <FaWhatsapp className='text-3xl sm:text-4xl text-[#25D366] shrink-0 group-hover:text-white transition-colors' aria-hidden />
              Book a call
            </a>
          </li>
        )}
        <li className='py-6'>
          <button
            onClick={() => { toggleTheme(); handleClick(); }}
            aria-label='Toggle dark mode'
            className='p-3 rounded-md border text-2xl border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800'
          >
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
